@if (loaded()) {
  <div class="pivot-card">
    <div class="pivot-card-content">
      <div class="pivot-card-header">
        <div class="pivot-card-title-row">
          <hyperkit-typography variant="emphasized" size="sm" color="primary">
            {{ title }}
          </hyperkit-typography>
        </div>
        <hyperkit-typography variant="body" size="sm" color="secondary">
          {{ description }}
        </hyperkit-typography>
      </div>
      <div class="pivot-card-tags">
        @if (required.length > 0) {
          <hyperkit-tag
            mode="outline"
            [closable]="false"
            textLeft="Required Fields"
            [text]="requiredFieldLabels"
          ></hyperkit-tag>
        }
        @if (optional.length > 0) {
          <hyperkit-tag
            mode="outline"
            [closable]="false"
            textLeft="Optional Fields"
            [text]="optionalFieldLabels"
          ></hyperkit-tag>
        }
      </div>
    </div>
    <div class="pivot-card-action">
      @if (selected) {
        <hyperkit-button
          variant="standard"
          color="destructive"
          size="small"
          text="Remove"
          icon="x"
          iconPosition="left"
          (click)="onToggleSelection()"
        ></hyperkit-button>
      }
      @if (!selected) {
        <hyperkit-button
          variant="standard"
          color="secondary"
          size="small"
          icon="plus"
          text="Add"
          (click)="onToggleSelection()"
        ></hyperkit-button>
      }
    </div>
  </div>
} @else {
  <p>Loading…</p>
}
